namespace ui
{
	export namespace fab
	{

		export interface IExpandableFABListOptions extends ui.base.IBaseHTMLElementDescriptor
		{
			guardian:
			{
				title:		string|number|JQuery|ui.base.BaseHTMLElement;
				options?:	ui.base.IButtonOptions;
			};
			expand:				'click'|'mouseenter';
			orientation?:	'left'|'up'|'right'|'down';
			position?:
			{
				top?:				string;
				bottom?:		string;
				left?:			string;
				right?:			string;
			};
			absolute?:		boolean;
		}

		function PreprocessOptions( options: IExpandableFABListOptions ): IExpandableFABListOptions
		{
			if ( !options.orientation )
			{
				options.orientation	= 'down';
			}
			if ( options.absolute === undefined )
			{
				options.absolute		= false;
			}
			if ( !options.position )
			{
				options.position		= { top: '0px', left: '0px' };
			}

			if ( !options.position.top && !options.position.bottom )
			{
				options.position.top	= '0px';
			}
			if ( !options.position.left && !options.position.right )
			{
				options.position.left	= '0px';
			}

			return options;
		}

		export class ExpandableFABList
			extends ui.base.HTMLPresentation
		{

			public readonly	Descriptor:	IExpandableFABListOptions;

			private		m_List:			ui.base.Button[];
			private		m_FAB:			ui.base.Button;
			private		m_State:		boolean;

			public constructor( options?: IExpandableFABListOptions )
			{
				super( 'fab-list' );

				this.Descriptor	= PreprocessOptions( options || { guardian: { title: '' }, expand: 'click' } );

				this.m_List			= new Array();
				this.m_FAB			= new ui.base.Button( this.Descriptor.guardian.title, this.Descriptor.guardian.options );
				this.m_State		= false;
			}

			public Initialize(): ExpandableFABList
			{
				super.Initialize( this.Descriptor );

				if ( this.Descriptor.absolute )
				{
					this.css( 'position', 'absolute' );
				}

				if ( this.Descriptor.orientation )
				{
					switch ( this.Descriptor.orientation )
					{
						case 'left':	this.addClass( 'horizontal reverse' );	break;
						case 'right':	this.addClass( 'horizontal' );					break;
						case 'up':		this.addClass( 'reverse' );							break;

						default: break;
					}
				}

				if ( this.Descriptor.position )
				{
					if ( this.Descriptor.position.top !== undefined )
					{
						this.css( 'top', this.Descriptor.position.top + 'px' );
					}

					if ( this.Descriptor.position.left !== undefined )
					{
						this.css( 'left', this.Descriptor.position.left + 'px' );
					}

					if ( this.Descriptor.position.right !== undefined )
					{
						this.css( 'right', this.Descriptor.position.right + 'px' );
					}

					if ( this.Descriptor.position.bottom !== undefined )
					{
						this.css( 'bottom', this.Descriptor.position.bottom + 'px' );
					}
				}

				const openCallback	= () => this.m_List.forEach( ( element ) => element.remClass( 'hidden' ) );
				const closeCallback	= () => this.m_List.forEach( ( element ) => element.addClass( 'hidden' ) );

				if ( this.Descriptor.expand === 'click' )
				{
					this.m_FAB.on(
						{
							click: () =>
							{
								if ( this.m_State )
								{
									closeCallback();
								}
								else
								{
									openCallback();
								}

								this.m_State	= !this.m_State;
							}
						}
					);
				}
				else if ( this.Descriptor.expand === 'mouseenter' )
				{
					this.m_FAB.on(
						{
							mouseenter: () =>	{	openCallback();		this.m_State	= !this.m_State;	},
							mouseleave: () =>	{	closeCallback();	this.m_State	= !this.m_State;	}
						}
					);
				}
				else
				{
					console.error( 'undefined expand event listener' );
				}

				return this;
			}

			public add( item: ui.base.Button ): ExpandableFABList
			{
				this.m_List.push( item );

				item.css( 'position', '' );

				return this;
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): ExpandableFABList
			{
				super.rebuild( root );

				this.empty();

				this.m_FAB.appendTo( this );

				this.m_List.forEach( ( element ) => element.appendTo( this ) );

				this.Initialize();

				return this;
			}

		}

	}
}
